import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { siteVisitService } from '../services/siteVisitService';

export const useSiteVisits = (filters = {}) => {
  const queryClient = useQueryClient();

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['siteVisits', filters],
    queryFn: async () => {
      const response = await siteVisitService.getSiteVisits({ ...filters, hasSiteVisit: true });
      const leads = response.data?.data || response.data?.leads || response.data || [];
      return Array.isArray(leads) ? leads : [];
    },
    staleTime: 15 * 60 * 1000, // 15 minutes: Data remains fresh
    cacheTime: 30 * 60 * 1000,
    refetchOnMount: false, // Don't refetch on mount if data is already in cache
    refetchOnWindowFocus: false, 
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => siteVisitService.submitSiteVisit(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries(['siteVisits']);
      queryClient.invalidateQueries(['leads']); 
    }
  });

  const deleteMutation = useMutation({
    mutationFn: (id) => siteVisitService.deleteSiteVisit(id),
    onSuccess: () => {
      queryClient.invalidateQueries(['siteVisits']);
      queryClient.invalidateQueries(['leads']);
    }
  });
  
  const toggleDisableMutation = useMutation({
    mutationFn: ({ id, isDisabled }) => siteVisitService.updateLead(id, { isDisabled }),
    onSuccess: () => {
      queryClient.invalidateQueries(['siteVisits']);
      queryClient.invalidateQueries(['leads']);
    }
  });

  return {
    siteVisits: data || [],
    isLoading,
    error,
    refetch,
    updateSiteVisit: updateMutation.mutateAsync,
    deleteSiteVisit: deleteMutation.mutateAsync,
    toggleDisableSiteVisit: toggleDisableMutation.mutateAsync,
    isUpdating: updateMutation.isPending,
    isDeleting: deleteMutation.isPending,
  };
};
